<template src="./AuthLayout.html"></template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({});
</script>

<style src="./AuthLayout.scss" scoped lang="scss"></style>
